export default class ModalPdfSignaturesController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} signatures
	 */
	constructor($uibModalInstance, signatures) {
		this.$uibModalInstance = $uibModalInstance;
		this.signatures = signatures;
	}

	close() {
		this.$uibModalInstance.close();
	}
}
